// Deutsche Formatierung – identisch in Backend (Sprachausgabe) und Frontend (UI).

/** Zahl mit Komma als Dezimaltrenner, maximal `maxDecimals` Nachkommastellen. */
export function formatNumber(n: number | null | undefined, maxDecimals = 2): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '–';
  const rounded = Math.round(n * 10 ** maxDecimals) / 10 ** maxDecimals;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded).replace('.', ',');
}

/** Menge + Einheit, z.B. „1,5 l" oder „3 Stück". */
export function formatAmount(amount: number | null | undefined, unit?: string | null): string {
  if (amount === null || amount === undefined) return unit ?? '';
  return unit ? `${formatNumber(amount)} ${unit}` : formatNumber(amount);
}

/** Euro-Betrag, z.B. „3,49 €". Erwartet Euro (nicht Cent). */
export function formatEuro(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '–';
  return `${value.toFixed(2).replace('.', ',')} €`;
}

export function formatKcal(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '– kcal';
  return `${Math.round(value)} kcal`;
}

/** Gramm-Angabe für Makros, z.B. „124 g". */
export function formatGrams(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '–';
  return `${Math.round(value)} g`;
}

/** „vor 3 Tagen" / „in 2 Tagen" / „heute" – für Haltbarkeit & Frische. */
export function relativeDays(days: number | null | undefined): string {
  if (days === null || days === undefined) return 'unbekannt';
  if (days === 0) return 'heute';
  if (days === 1) return 'morgen';
  if (days === -1) return 'gestern';
  if (days > 0) return `in ${days} Tagen`;
  return `vor ${Math.abs(days)} Tagen`;
}

/** Aufzählung mit „und" vor dem letzten Element („A, B und C"). */
export function joinDe(parts: readonly string[]): string {
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0]!;
  return `${parts.slice(0, -1).join(', ')} und ${parts[parts.length - 1]!}`;
}

/**
 * Produktnamen für die Anzeige kürzen: an Trennern/Werbetext kappen, max. 4 Wörter.
 * Der volle Originaltext bleibt als Erkennungs-Alias erhalten.
 */
export function shortenName(s: string | null | undefined, maxWords = 4): string {
  const raw = String(s ?? '').trim();
  // Wichtig: nur an einem Komma MIT Leerzeichen trennen. „3,5% Fett" ist ein
  // Wert, „Gouda jung, geschnitten" eine Aufzählung.
  const cut = raw.split(/[;(]|,\s|\s[-–]\s/)[0]?.trim() ?? '';
  const words = cut.split(/\s+/).slice(0, maxWords).join(' ');
  return words || raw.slice(0, 30);
}
